// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__e2kFq","modalContent":"Modal_modalContent__Whu1Q"};